import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationAdminWebhooksHistoryDetailsKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        webhooks_history: {
          history_details: {
            header: 'HEADER_DETAILS',
            back: 'BACK',
            request_details: {
              header: 'REQUEST_DETAILS_HEADER',
              execution_status_title: 'REQUEST_DETAILS_EXECUTION_STATUS_TITLE',
              statuses: {
                completed_without_errors: 'REQUEST_DETAILS_STATUS.completed_without_errors',
                interrupted_with_external_errors: 'REQUEST_DETAILS_STATUS.interrupted_with_external_errors',
                interrupted_with_internal_errors: 'REQUEST_DETAILS_STATUS.interrupted_with_internal_errors',
              },
              error_messages_title: 'REQUEST_DETAILS_ERROR_MESSAGES_TITLE',
            },
          },
        },
      },
    },
  }));
}
